// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"cc0a6517","237":"76af947c","332":"61d4f652","434":"fa82cdf6","523":"2d2d27f0","731":"3ebf8d0b","947":"086dbf4c"}[chunkId] + ".chunk.css";
};